import { Form } from '@mairistem/composants';
import { Panel } from '@mairistem/finances-utils';
import React from 'react';
import type PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';

const ProjetComponent = ({
	// biome-ignore lint/correctness/noUnusedFunctionParameters: Le composant n'est pas fini
	data,
	handlePin,
	onChange,
	panel,
}: PanelComponentProps) => {
	const handleChange = (_e, { name, value }) =>
		onChange?.({ [name]: value }, panel);

	return (
		<Panel panel={panel} onPin={handlePin}>
			<Form>
				<Form.Group>
					<Form.Input
						name="identifiantProjet"
						key="identifiantProjet"
						label="Intitulé du projet"
						fluid
						width={16}
						value=""
						onChange={handleChange}
						data-testid="projetSubventionPanel"
					/>
				</Form.Group>
			</Form>
		</Panel>
	);
};

export default ProjetComponent;
